import React, {ChangeEvent, ReactNode} from 'react'
import {DateFormatter, DayPicker} from 'react-day-picker'
import 'react-day-picker/dist/style.css'
import './DayPicker.css'
import {Nullable} from '../../../app/TypeHelpers'
import moment from 'moment'
import {Popover} from '@mui/material'
import 'moment/locale/ja'
import {DisplayItemSelectLikeDiv, DisplayItemSelectWrapper} from '../../../styledComponents/DisplayItem'
import styled from 'styled-components'
import {format} from 'date-fns'
import {ja} from 'date-fns/locale'

export interface DatePickerProps {
    date?: Nullable<string>
    onChange?: (date: string) => void
    disabled?: boolean
    hasError?: boolean
    itemValue? : string
    selectableStartDate?: moment.Moment
    selectableEndDate?: moment.Moment
    holidays: string[]
}

interface State {
    anchorEL: Nullable<HTMLElement>
    selectedMoment: Nullable<moment.Moment>
}

const formatCaption: DateFormatter = (date, options) => {
    const y = new Date(date.toLocaleString('ja')).getFullYear();
    const m = format(date, 'MM', { locale: ja });
    return `${y}年 ${Number(m)}月`;
}
export default class DatePickerForResident extends React.Component<DatePickerProps, State> {

    constructor(props: Readonly<DatePickerProps>) {
        super(props)
        this.state = {
            anchorEL: null,
            selectedMoment: null,
        }
        this.handleOnDayClick = this.handleOnDayClick.bind(this)
        this.handleChangeDate = this.handleChangeDate.bind(this)
    }

    componentDidMount(): void {
        this.updateStateDate()
    }

    componentDidUpdate(prevProps: Readonly<DatePickerProps>, prevState: Readonly<State>, snapshot?: any): void {
        const thisPropsMoment = (this.props.date) ? moment(this.props.date) : null
        if (prevProps.date === this.props.date || this.state.selectedMoment === thisPropsMoment) {
            return
        }
        this.updateStateDate()
    }

    updateStateDate(): void {
        this.setState({
            selectedMoment: this.props.date ? moment(this.props.date) : null,
        })
    }

    handleOnDayClick(day: Date): void {
        this.setState({
            anchorEL: null,
            selectedMoment: moment(day),
        }, () => {
            const {selectedMoment} = this.state
            if (this.props.onChange) {
                this.props.onChange(
                    (selectedMoment !== null)
                        ? selectedMoment.format('YYYY-MM-DD')
                        : '',
                )
            }
        })
    }

    handleChangeDate(event: ChangeEvent<HTMLInputElement>): void {
        this.handleOnDayClick(moment(event.target.value).toDate())
    }

    render(): ReactNode {
        const {selectedMoment, anchorEL} = this.state
        const {selectableStartDate, selectableEndDate} = this.props

        let selectableEndMonth: Nullable<moment.Moment> = null
        if (selectableEndDate) {
            selectableEndMonth = selectableEndDate
        } else if(selectableStartDate) {
            selectableEndMonth = selectableStartDate.clone().add(1, 'year').month(11)
        }

        const itemValue: string = (selectedMoment !== null)
            ? selectedMoment.format('YYYY年M月D日(ddd)')
            : (this.props.itemValue　!== undefined)
                ? this.props.itemValue
                : '日付を選択してください'
        let hasError: boolean = false
        if (this.props.hasError) {
            hasError = this.props.hasError
        }
        const holidayList = this.props.holidays.map(holiday => new Date(holiday))
        const modifiers = {
            sun: {dayOfWeek: [0]},
            sat: {dayOfWeek: [6]},
            holidays: holidayList
        }
        const modifiersStyles = {
            sun: {color: '#ff0000'},
            sat: {color: '#0000ff'},
            holidays: {color: '#ff0000'},
        }
        return <>
            <div
                onClick={(event: React.MouseEvent<HTMLElement>) => {
                    if (this.props.disabled) {
                        return
                    }
                    event.preventDefault()
                    this.setState({
                        anchorEL: event.currentTarget,
                    })
                }}>
                <DisplayItemSelectWrapper>
                    <DisplayItemSelectLikeDiv hasError={hasError}
                                              disabled={this.props.disabled}>{itemValue}</DisplayItemSelectLikeDiv>
                </DisplayItemSelectWrapper>
            </div>
            <input
                style={{display: 'none'}}
                type={'date'}
                value={this.props.date || ''}
                onChange={this.handleChangeDate}/>
            <Popover
                open={(anchorEL !== null)}
                anchorEl={anchorEL}
                onClose={() => {
                    this.setState({anchorEL: null})
                }}
            >
                <WrappedDayPicker
                    modifiers={modifiers}
                    modifiersStyles={modifiersStyles}
                    disabled={(selectableStartDate)
                        ? {before: selectableStartDate.toDate()}
                        : undefined
                    }
                    fromMonth={(selectableStartDate)
                        ? selectableStartDate.toDate()
                        : undefined
                    }
                    toMonth={(selectableEndMonth)
                        ? selectableEndMonth.toDate()
                        : undefined
                    }
                    selected={
                        (selectedMoment !== null)
                            ? [selectedMoment.toDate()]
                            : undefined
                    }
                    defaultMonth={(selectedMoment !== null)
                        ? selectedMoment.toDate()
                        : undefined
                    }
                    locale={ja}
                    formatters={{ formatCaption }}
                    onDayClick={this.handleOnDayClick}
                />
            </Popover>
        </>
    }
}

const WrappedDayPicker = styled(DayPicker)`
  word-break: normal;
  line-height: 1.15;
  .rdp-day_today {
    color: #3f51b5;
    font-weight: normal;
   }
  .rdp-day_selected {
    color: white;
  }
  .rdp-day_disabled {
    color: #505050!important;
   }
`

